@charset 'utf-8';
// ==========================================================================
// Sassy Starter by Mina Markham
// A SMACSS-based starter toolkit for SCSS projects
//
// The toolkit uses recommendations from Scalable and Modular Architecture for CSS (SMACSS)
// @link http://smacss.com/book
//
// Site:    https://minamarkham.github.io/sassy-starter
// Author:  Mina Markham
// Email:   mina@mina.codes
// Date:    10/25/15
// ==========================================================================

// CSS Debugging
//
// Toggle layout debugging with CSS Pesticide.
//
// $pesticide-debug-outline - {boolean} adds outlines to all elements.
// $pesticide-debug-depth - {boolean} adds shadows to all elements.
// @source - http://pesticide.io/
@use "libs/pesticide" with (
  $pesticide-debug-outline: false,
  $pesticide-debug-depth: false
);

// ==========================================================================
// $Libs
// ==========================================================================
@use "libs/index";

// ==========================================================================
// $Utilities
// ==========================================================================
@use "utilities/index" as index2;
// ==========================================================================
// $Base
// ==========================================================================
@use "base/index" as index3;
// ==========================================================================
// $Modules
// ==========================================================================
@use "modules/index" as index4;
// ==========================================================================
// $States
// ==========================================================================
@use "states/index" as index5;
// ==========================================================================
// $Fonts
// ==========================================================================
@use "utilities/fonts";
// ==========================================================================
// $Shame
// ==========================================================================
@use "shame";
